import { Identity } from "./identity";

export class AuthenticationData {
    public deviceId: string = null;
    public identity: Identity = null;
    public refreshToken: string = null;
    public tenantId: number = null;
    public locationId: number = null;
    public featureFlags: string[] = [];
}
